import { TreeNode } from "@/types/tree";
import { getDomElementFromTreeNode } from "@/lib/canvas/helpers";
import store from "@/store/store";
import { forceNextTick } from "@/util/force-next-tick";

export type ElementPositionOnCanvas =
  | {
      left: string;
      top: string;
      width: string;
      height: string;
    }
  | false;

export function calculateDomElementPositionOnCanvas(
  domElement: HTMLElement
): ElementPositionOnCanvas {
  const rect = domElement.getBoundingClientRect();

  const scrollLeft = window.Breakdance.canvas.document.documentElement.scrollLeft;
  const scrollTop = window.Breakdance.canvas.document.documentElement.scrollTop;

  return {
    left: `${rect.left + scrollLeft}px`,
    top: `${rect.top + scrollTop}px`,
    width: `${rect.width}px`,
    height: `${rect.height}px`
  };
}

export function calculateElementPositionOnCanvas(
  element: TreeNode
): ElementPositionOnCanvas {
  const domElement = getDomElementFromTreeNode(element);
  if (!domElement) {
    return false;
  }
  return calculateDomElementPositionOnCanvas(domElement);
}

export function listenForDomElementPositionChanges(
  domElement: HTMLElement,
  callback: (newPosition: ElementPositionOnCanvas) => void
): () => void {
  const handler = () => {
    forceNextTick(() => {
      callback(calculateDomElementPositionOnCanvas(domElement));
    });
  };

  const interval = setInterval(handler, 500);
  window.addEventListener("resize", handler);

  return () => {
    window.removeEventListener("resize", handler);
    clearInterval(interval);
  };
}

export function listenForPositionChangesAndGetNewPosition(
  element: TreeNode,
  callback: (newPosition: ElementPositionOnCanvas) => void
): () => void {
  const handler = () => {
    forceNextTick(() => {
      callback(calculateElementPositionOnCanvas(element));
    });
  };

  const unsubscribeFromStore = store.subscribe(handler);
  const interval = setInterval(handler, 500);

  window.addEventListener("resize", handler);

  return () => {
    window.removeEventListener("resize", handler);
    unsubscribeFromStore();
    clearInterval(interval);
  };
}

export function getWrapperStyle(elementPositionOnCanvas: ElementPositionOnCanvas): Record<string, string> {
  if (!elementPositionOnCanvas) {
    return { display: "none" };
  }

  return {
    left: elementPositionOnCanvas.left,
    top: elementPositionOnCanvas.top,
    width: "0px",
    height: "0px"
  };
}

export function getOutlineStyle(elementPositionOnCanvas: ElementPositionOnCanvas): Record<string, string> {
  if (!elementPositionOnCanvas) {
    return { display: "none" };
  }

  return {
    left: "0px",
    top: "0px",
    width: elementPositionOnCanvas.width,
    height: elementPositionOnCanvas.height
  };
}
